export interface InventarioStateProps {
  objeto?: {
    isTrue?: boolean
    isFalse?: boolean
  }
  string?: string
  number?: number
  date?: Date[]
}

export const inventario: InventarioStateProps = {
  objeto: {
    isTrue: true,
    isFalse: false,
  },
  string: "string",
  number: 123,
  date: [new Date(`${new Date().getFullYear()}-01-01`), new Date()],
}
